/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import { getElementCSSProperty } from 'utils/embeds/styles';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/editabletext/editabletext_styles';



/* ========== ~~~~~~~~~~ EDITABLE TEXT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EditableText extends Component {
    componentDidMount(){
       if (!this.props.isOption) { this.props.validateText(this.props.contentTitle) }
    }
    componentWillReceiveProps(nextProps){
        if (!this.props.isOption &&  (this.props.contentTitle !== nextProps.contentTitle)) { this.props.validateText(nextProps.contentTitle) }
    }
    shouldComponentUpdate(nextProps) {
        if (this.props.contentId === nextProps.contentId) {
            if (this.props.optionText !== nextProps.optionText || this.props.contentTitle !== nextProps.contentTitle
            ) {return true
            }else if (this.props.isSelected && this.props.isEditable && this.props.contentTitle !== nextProps.contentTitle && nextProps.contentTitle !== null) {
                return false;
            } else if (this.props.isEditable && this.props.optionText !== nextProps.optionText) {
                return false;
            } else {
                return true;
            }
        }
        return true;
    };
    handleKeyDown = (e) => {
        if (this.props.onKeyDown !== undefined) { this.props.onKeyDown(e.target.textContent, getElementCSSProperty(e.target, 'height')); }
        if (this.props.preventEnter && e.which === 13) { e.preventDefault(); return false; }
        // check if we've hit character limit (passed in as prop)
        if (this.props.characterLimit !== undefined) {
            if ((e.target.textContent.length >= this.props.characterLimit) && (e.key.length === 1)) {
                e.preventDefault();
            }
        }
    };
    handleKeyUp = (e) => {
        if (this.props.onKeyUp !== undefined) { this.props.onKeyUp(e.target.textContent, getElementCSSProperty(e.target, 'height')); }
        // needed to dynamically resize text via classes and callback functions
        if (this.props.onTextEdit !== undefined) {
            this.props.onTextEdit(e.target.textContent, e);
        }
    };
    handleFocus = (e) => {
        if (this.props.onFocus !== undefined) { this.props.onFocus(e.target.textContent, getElementCSSProperty(e.target, 'height')); }
    };
    handleBlur = (e) => {
        if (this.props.onBlur !== undefined) {
            this.props.onBlur(e.target.textContent, getElementCSSProperty(e.target, 'height'));
            // push text to store (question vs option)
            switch (this.props.isOption) {
                case true:
                    this.props.updateOptionProperty(this.props.contentId, this.props.optionId, 'text', e.target.textContent);
                    break;
                case false:
                default:
                    return this.props.isStory ? this.props.setStoryProperty(this.props.contentId, 'title', e.target.textContent) :
                        this.props.setQBProperty(this.props.contentId, 'title', e.target.textContent);
            }
        }
    };
    handlePaste = (e) => {
        e.preventDefault();
        let text = e.clipboardData.getData("text/plain");
        // This will prevent users from pasting more than allowed characters in the div
        if (this.props.characterLimit !== undefined && typeof this.props.characterLimit === 'number') {
            text = e.clipboardData.getData("text/plain").slice(0, (this.props.characterLimit - e.target.textContent.length));
        }
        let temp = document.createElement("div");
        temp.innerHTML = text;
        document.execCommand("insertHTML", false, temp.textContent);
    };
    render() {
        return (
            <div ref={function (e) { if (e != null) e.contentEditable = true; }} style={this.props.style} className={`editabletext ${this.props.classes.editabletext}`} data-text={this.props.placeholder !== undefined ? this.props.placeholder : this.props.isOption ? 'Type answer' : 'Type your question here'} onKeyUp={this.handleKeyUp} onKeyDown={this.handleKeyDown} onFocus={this.handleFocus} onBlur={this.handleBlur} onPaste={this.handlePaste}>
                {this.props.isOption ? this.props.optionText : this.props.contentTitle}
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EditableText);
